// extracted by mini-css-extract-plugin
export default {"root":"SystemDown_root__NpEZJ","errorCode":"SystemDown_errorCode__CyROx"};